import { render, staticRenderFns } from "./Notas-de-pedido.vue?vue&type=template&id=2e2e1850&scoped=true"
import script from "./Notas-de-pedido.vue?vue&type=script&lang=js"
export * from "./Notas-de-pedido.vue?vue&type=script&lang=js"
import style0 from "./Notas-de-pedido.vue?vue&type=style&index=0&id=2e2e1850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2e1850",
  null
  
)

export default component.exports